<template>
    <div class="income_records">
        <div class="select_box">
            <div class="time_select_box">
                <el-date-picker v-model="orderData" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div class="order_select_box">
                <span>筛选</span>
                <el-select v-model="orderValue" clearable placeholder="全部类型">
                    <el-option
                        v-for="item in orderOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </div>
            <div class="search_input_box">
                <el-input placeholder="商品名称、订单号" v-model="orderOrGoods" clearable> </el-input>
            </div>
            <div class="search_btn">
                <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
            </div>
            <div class="export_btn">
                <el-button plain @click="exportClick">导出</el-button>
            </div>
        </div>
        <div class="table_box">
            <el-table :data="allRecordsData" style="width: 100%">
                <el-table-column prop="productname" label="商品名称" align='left'></el-table-column>
                <el-table-column prop="orderno" label="订单号" align='center'></el-table-column>
                <el-table-column prop="datetime" label="时间" align='center'></el-table-column>
                <el-table-column prop="tradetypetext" label="交易类型" align='center'></el-table-column>
                <el-table-column prop="tradesourcetext" label="交易方式" align='center'></el-table-column>
                <el-table-column label="入账/支出（元）" align='center'>
                    <template slot-scope="scope">
                        <span :class="status(scope.row.moneydirect)">{{trademoney(scope.row.moneydirect, scope.row.trademoney)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="memo" label="备注" align='center'></el-table-column>
            </el-table>
        </div>
        <page :total="total" ref="page" @getList="searchClick"></page>
    </div>
</template>

<script>
import {findBillToList, exportOrdersList} from 'api/materialMgtApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    props: ['data'],
    data() {
        return {
            total: 0,
            orderOrGoods: '',
            pickerOptions2: {
                shortcuts: [
                    {
                        text: '今日',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '昨日',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            end.setTime(start.getTime() - 3600 * 1000)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            orderData: '',
            orderOptions: [
                {
                    value: '',
                    label: '全部类型'
                },
                {
                    value: 1,
                    label: '充值'
                }, {
                    value: 3,
                    label: '退款'
                }, {
                    value: 4,
                    label: '收入'
                }, {
                    value: 11,
                    label: '冲正'
                }
            ],
            orderValue: '',
            allRecordsData: []
        }
    },
    mounted() {},
    methods: {
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        exportClick() {
            if (this.orderData === null) {
                this.orderData = []
            }
            this.setLoading(true)
            var params = {
                beginTime: this.orderData[0],
                endTime: this.orderData[1],
                orderno: this.orderOrGoods,
                tradetype: this.orderValue,
                moneydirect: 1
            }
            exportOrdersList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '余额账户' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 搜索按钮
        searchClick() {
            if (this.orderData === null) {
                this.orderData = []
            }
            this.setLoading(true)
            var params = {
                beginTime: this.orderData[0],
                endTime: this.orderData[1],
                orderno: this.orderOrGoods,
                tradetype: this.orderValue,
                moneydirect: 1
            }
            findBillToList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.allRecordsData = data.data
                    if (data.pageableData !== undefined) {
                        this.total = data.pageableData.rowCount
                    }
                    if (data.data == '') {
                        this.allRecordsData = []
                    }
                    if (data.pageableData == '') {
                        this.total = 0
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        trademoney(key, value) {
            if (key === 1) {
                return '+' + value
            } else if (key === 2) {
                return '-' + value
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {
        status (value) {
            let cls = ''
            if (value > 0) {
                cls = '+' + value
            } else {
                cls = value
            }
            return cls
        }
    },
    watch: {
        data(newVal, oldVal) {
            // if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
            //     return
            // }
            this.$nextTick(() => {
                this.allRecordsData = this.data.data
                if (this.data.pageableData !== undefined) {
                    this.total = this.data.pageableData.rowCount
                }
                if (this.data.data === '') {
                    this.allRecordsData = []
                }
                if (this.data.pageableData === '') {
                    this.total = 0
                }
            })
        }
    },
    computed: {
        status () {
            return function(value) {
                if (value === 1) {
                    return 'green'
                } else if (value === 2) {
                    return 'red'
                }
            }
        },
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {
        Page
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .income_records{
        .select_box{
            // height: 36px;
            // margin-top: 18px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            // margin-top: 10px;
            &>div{
                // background-color: red;
                margin-top: 20px;
                height: 36px;
                margin-right: 30px;
                display: flex;
                align-items: center;
                &>span{
                    white-space: nowrap;
                    margin-right:10px;
                    color:rgba(48,49,51,1);
                    font-size:14px;
                }
                .el-input__icon {
                    line-height: 0;
                }
                .el-input--suffix .el-input__inner {
                    padding-right: 10px;
                }
                .el-input__inner {
                    height: 36px;
                    line-height: 36px;
                    width: 224px;
                }
            }
            .time_select_box{
                span{
                    color: #303133;
                    font-family:PingFangSC-Regular;
                    cursor: pointer;
                }
                span:hover{
                    color: #409EFF;
                }
                .is_select{
                    color: #409EFF;
                }
                .el-input__inner {
                    width: 256px;
                }
                .el-input__icon {
                    line-height: 30px;
                }
                .el-date-editor .el-range-separator {
                    color: #C0C4CC;
                }
                .el-date-editor .el-range-input, .el-date-editor .el-range-separator {
                    height: auto;
                }
            }
            .order_select_box{
                padding-bottom: 5px;
                &>span{
                    margin-top: 5px;
                }
            }
            .search_input_box{
                padding-bottom: 5px;
                &>span{
                    margin-top: 5px;
                }
                .el-input__inner {
                    width: 256px;
                }
                .el-input__icon {
                    line-height: 36px;
                }
            }
            .search_btn{
                .el-button, .el-button--mini {
                    min-width: 95px;
                }
            }
            .export_btn{
                .el-button, .el-button--mini {
                    min-width: 95px;
                }
            }
        }
        .table_box{
            margin-top: 30px;
            .el-table th>.cell {
                color: #303133;
                font-weight: bold;
                white-space: nowrap;
            }
            .red{
                color: #F56C6C;
            }
            .green{
                color: #67C23A;
            }
        }
        .paging_box {
            margin-top: 30px;
            display: flex;
            justify-content: center;
        }
    }
</style>